module.exports = __webpack_public_path__ + "img/stamp-fish.0474af92.png";